<template>
  <div class="printcontainer boxes">
    <h3><Icon type="md-bookmarks" />重点风险案例（前五）<slot name="right"></slot></h3>
    <ul class="zhoongdiananli"  v-for="(item, index1) in imgs" :key="index1">
      <li v-for="(x, index) in item" :key="index">
        <div class="imgs">
          <img :src="x.fileUrl" />
          <p class="alarm">{{ x.alarmEvent }}</p>
        </div>

        <h4>{{ x.carNo }}</h4>

        <p class="time">{{ x.uploadTime2 }}</p>
        <p>{{ x.alarmAddres }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgs: [],
    };
  },
  methods: {
    getData(v) {
      v.limit = 5;
      v.alarmEventList =["疲劳驾驶报警", "接打电话报警", "分神驾驶报警", "前向碰撞报警", "车道偏离报警", "车距过近报警", "抽烟报警"] ;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countCase",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        var data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < data[i].length; j++) {
            data[i][j].uploadTime2 = this.utils.time(
              data[i][j].uploadTime,
              "yymmddhhmm"
            );
          }
        }
        this.imgs = [];
        data.forEach(v => {
          if (v.length > 0) {
            this.imgs.push(v);
          }
        });
        //"https://v.ly-gps.com/files/alarm_files/202307/13306240374_230701002445_1/00_65_6501_02_20230701002814579.jpg"
      });
    },
  },
  mounted() {},
};
</script>
<style>
.zhoongdiananli {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 20px;
}
.zhoongdiananli:last-child {
  margin-bottom: 0px;
}
.zhoongdiananli li {
  width: calc(20% - 16px);
  margin-right: 20px;
  margin-bottom: 20px;
}
.zhoongdiananli li:nth-child(5n) {
  margin-right: 0px;
}
.zhoongdiananli li img {
  width: 100%;
 aspect-ratio: 16/9;
 
}
.zhoongdiananli li h4 {
  font-size: 18px;
  margin-top: 10px;
}
.zhoongdiananli li .imgs {
  position: relative;
}
.zhoongdiananli li .imgs img {
  display: block;
}
.zhoongdiananli li p.alarm {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #ea2d2d;
  padding: 2px 6px;
  color: #fff;
  border-radius: 6px 0 0 0;
}
.zhoongdiananli li p.time {
  margin-bottom: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/fengxiananli.vue